import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield}}\n", {
  moduleName: "ember-animated/templates/components/animated-orphans.hbs"
});